import store from "@/state/store"
import { CHAVE_PREFERENCIAS } from "@/components/preferencias"

let token = window.localStorage.getItem("token")

export default [
    {
        path: "/",
        name: "default",
        meta: {authRequired: true},
        component: () => import("./views/home"),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (token) {
                    next({name: 'default'})
                } else {
                    next()
                }
            },
        },
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: () => import("./views/account/login"),
    //   meta: {
    //     beforeResolve(routeTo, routeFrom, next) {
    //       // If the user is already logged in
    //       if (store.getters["auth/loggedIn"]) {
    //         // Redirect to the home page instead
    //         next({ name: "default" });
    //       } else {
    //         // Continue to the login page
    //         next();
    //       }
    //     },
    //   },
    // },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Recuperar Senha",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                const preferencias = window.localStorage.getItem(CHAVE_PREFERENCIAS)
                window.localStorage.clear()
                if (preferencias !== null) window.localStorage.setItem(CHAVE_PREFERENCIAS, preferencias)
                window.sessionStorage.clear()
                window.location.replace("/login")
                return [routeTo, routeFrom, next, store]
            },
        },
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations

    // Dashboard
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {authRequired: true},
        component: () => import('./views/dashboard')
    },

    // Aluno
    {
        path: '/aluno',
        name: 'aluno',
        meta: {authRequired: true},
        component: () => import('./views/alunov2/index.vue')
    },
    {
        path: '/aluno/dados-pessoais',
        name: 'aluno.dado.pessoal',
        meta: {authRequired: true},
        component: () => import('./views/aluno/dado-pessoal')
    },
    {
        path: '/aluno/registros-contato',
        name: 'aluno.registro.contato',
        meta: {authRequired: true},
        component: () => import('./views/aluno/registro-contato')
    },
    {
        path: '/aluno/analise-curricular',
        name: 'aluno.analise.curricular',
        meta: {authRequired: true},
        component: () => import('./views/aluno/analise-curricular')
    },
    {
        path: '/aluno/aproveitamento',
        name: 'aluno.aproveitamento',
        meta: {authRequired: true},
        component: () => import('./views/aluno/aproveitamento')
    },
    {
        path: '/aluno/atividades',
        name: 'aluno.atividade',
        meta: {authRequired: true},
        component: () => import('./views/aluno/atividade')
    },
    {
        path: '/aluno/documentos-entregues',
        name: 'aluno.documento.entregue',
        meta: {authRequired: true},
        component: () => import('./views/aluno/documento-entregue')
    },
    {
        path: '/aluno/financeiro',
        name: 'aluno.financeiro',
        meta: {authRequired: true},
        component: () => import('./views/aluno/financeiro')
    },
    {
        path: '/aluno/matriculas',
        name: 'aluno.matricula',
        meta: {authRequired: true},
        component: () => import('./views/aluno/matricula')
    },
    {
        path: '/aluno/notas',
        name: 'aluno.nota',
        meta: {authRequired: true},
        component: () => import('./views/aluno/nota')
    },


    // Gestão Acadêmica
    {
        path: '/gestao-academica/documentos-nao-entregues',
        name: 'gestao.academica.documento.nao.entregue',
        meta: {authRequired: true},
        component: () => import('./views/gestao-academica/documento-nao-entregue')
    },
    {
        path: '/gestao-academica/alunos',
        name: 'gestao.academica.aluno',
        meta: {authRequired: true},
        component: () => import('./views/gestao-academica/aluno')
    },
    {
        path: '/gestao-academica/dependencias',
        name: 'gestao.academica.dependencia',
        meta: {authRequired: true},
        component: () => import('./views/gestao-academica/dependencia')
    },
    {
        path: '/gestao-academica/aniversariantes',
        name: 'gestao.academica.aniversariante',
        meta: {authRequired: true},
        component: () => import('./views/gestao-academica/aniversariante')
    },
    {
        path: '/gestao-academica/relatorio-notas',
        name: 'gestao.academica.relatorio.notas',
        meta: { authRequired: true },
        component: () => import('./views/gestao-academica/relatorio-notas')
    },


    // Retenção
    {
        path: '/retencao/acesso-ava',
        name: 'retencao.acesso.ava',
        meta: {authRequired: true},
        component: () => import('./views/retencao/acesso-ava')
    },
    {
        path: '/retencao/atividades',
        name: 'retencao.atividade',
        meta: {authRequired: true},
        component: () => import('./views/retencao/atividade')
    },
    {
        path: '/retencao/solicitacao-evasao',
        name: 'retencao.solicitacao.evasao',
        meta: {authRequired: true},
        component: () => import('./views/retencao/solicitacao-evasao')
    },


    // FINANCEIRO
    // {
    //   path: '/financeiro/parcelas',
    //   name: 'financeiro.parcela',
    //   meta: { authRequired: true },
    //   component: () => import('./views/financeiro/parcela')
    // },
    {
        path: '/financeiro/parcelas-gerais',
        name: 'financeiro.parcela.geral',
        meta: {authRequired: true},
        component: () => import('./views/financeiro/parcela-geral')
    },
    {
        path: '/financeiro/parcelas-aberto',
        name: 'financeiro.parcela.aberto',
        meta: {authRequired: true},
        component: () => import('./views/financeiro/parcela-aberto')
    },
    {
        path: '/financeiro/parcelas-baixadas',
        name: 'financeiro.parcela.baixada',
        meta: {authRequired: true},
        component: () => import('./views/financeiro/parcela-baixada')
    },


    // Captação
    {
        path: '/captacao/inscricoes',
        name: 'captacao.inscricao',
        meta: {authRequired: true},
        component: () => import('./views/captacao/inscricao')
    },
    {
        path: '/captacao/inscricoes_pos',
        name: 'captacao.inscricao_pos',
        meta: {authRequired: true},
        component: () => import('./views/captacao/inscricao-pos/InscricaoPosIndex.vue')
    },
    {
        path: '/captacao/oferta-cursos',
        name: 'captacao.oferta.curso',
        meta: {authRequired: true},
        component: () => import('./views/captacao/oferta-curso')
    },


    // Links Úteis
    {
        path: '/links-uteis',
        name: 'link.util',
        meta: {authRequired: true},
        component: () => import('./views/link-util')
    },

    // Admin
    {
        path: '/admin/usuarios',
        name: 'admin.usuario',
        meta: {authRequired: true},
        component: () => import('./views/admin/usuario')
    },
    {
        path: '/admin/links-uteis',
        name: 'admin.link.util',
        meta: {authRequired: true},
        component: () => import('./views/admin/link-util')
    },

    // Master
    {
        path: '/master/usuarios',
        name: 'master.usuario',
        meta: {authRequired: true},
        component: () => import('./views/master/usuario')
    },
    {
        path: '/master/polos',
        name: 'master.polo',
        meta: {authRequired: true},
        component: () => import('./views/master/polo')
    },
    {
        path: '/master/links-uteis',
        name: 'master.link.util',
        meta: {authRequired: true},
        component: () => import('./views/master/link-util')
    },
    {
        path: '/master/logs-acesso',
        name: 'master.log.acesso',
        meta: {authRequired: true},
        component: () => import('./views/master/log-acesso')
    },
    {
        path: '/master/relatorio-acessos',
        name: 'master.relatorio.acessos',
        meta: {authRequired: true},
        component: () => import('./views/master/relatorio-acessos')
    },
    {
        path: '/master/analytics',
        name: 'master.analytics',
        meta: {authRequired: true},
        component: () => import('./views/master/analytics')
    },
    {
        path: '/master/rotinas',
        name: 'master.rotinas',
        meta: {authRequired: true},
        component: () => import('./views/master/rotinas')
    },
    {
        path: '/master/notificacoes',
        name: 'master.notificacoes',
        meta: {authRequired: true},
        component: () => import('./views/master/notificacoes')
    },
    {
        path: '/master/intakes',
        name: 'master.intakes',
        meta: {authRequired: true},
        component: () => import('./views/master/intakes')
    },
    {
        path: '/versao',
        name: 'versao',
        meta: {authRequired: true},
        component: () => import('./views/versao')
    },
    {
        path: '/notificacoes',
        name: 'notificacoes',
        meta: {authRequired: true},
        component: () => import('./views/notificacoes')
    },
    // {
    //   path: "*",
    //   redirect: "404",
    // },
];